module.exports = __webpack_public_path__ + "static/media/header-2.a66b61f6.png";